<template>
  <div :style="myBlockProps.getStyles(visible)">
    <a :href="myButtonProps.link" :style="myTextProps.getStyles()">
      <img v-if="myButtonProps.image" :src="myButtonProps.image" :alt="myButtonText.getText(selectedLanguage)"/>
      <span v-if="myButtonText" >{{ myButtonText.getText(selectedLanguage) }}</span>
    </a>
  </div>
</template>

<script>
import ButtonBlock from '../ButtonBlock.vue';

import { LinkButtonProps } from '../../models';

export default {
  name: 'link-button-block',
  extends: ButtonBlock,
  computed: {
    myButtonProps() {
      return new LinkButtonProps(this.buttonProps);
    }
  }
};
</script>

<style scoped>
  img {
    max-width: 100%;
    max-height: 100%;
    margin: auto;
  }

  a {
    text-decoration: none;
  }
</style>
